<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data, $index) in langData"
          :key="$index"
          :class="{ active: $index == 0 }"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true ? 'tab' + $index : ''"
            data-toggle="tab"
            :href="true ? '#tab-' + $index : ''"
            aria-expanded="true"
            @click="showTab($event, $index)"
            >{{ $t("message." + data) }}</a
          >
        </li>
      </ul>
    </div>
    
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(bannerItem, index) in bannerDetail.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.TopBanner name") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="bannerItem.topBannerName"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Banner Name - ' + langLabel(bannerItem.langCode)"
                      :maxlength="bannerItem.langCode=='en_US'?30:10"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">
                    {{ errors.first("Banner Name - " + langLabel(bannerItem.langCode))}}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.title") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="bannerItem.title"
                      data-vv-validate-on="blur"
                      :name="'Title - ' + langLabel(bannerItem.langCode)"
                      autocomplete="off"
                      :maxlength="bannerItem.langCode=='en_US'?60:30"
                      v-validate="'required'"
                    />
                    <label class="error">{{
                      errors.first(
                        "Title - " + langLabel(bannerItem.langCode)
                      )
                    }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.Name") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="bannerItem.name"
                      data-vv-validate-on="blur"
                      :name="'Name - ' + langLabel(bannerItem.langCode)"
                      autocomplete="off"
                      :maxlength="bannerItem.langCode=='en_US'?60:30"
                      v-validate="'required'"
                    />
                    <label class="error">{{
                      errors.first(
                        "Name - " + langLabel(bannerItem.langCode)
                      )
                    }}</label>
                  </div>
                </div>
              </div>
 
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.shortDescription") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="bannerItem.shortDescription"
                      data-vv-validate-on="blur"
                      :name="'Short Description - ' + langLabel(bannerItem.langCode)"
                      autocomplete="off"
                      :maxlength="bannerItem.langCode=='en_US'?180:90"
                      v-validate="'required'"
                    />
                  </div>
                  <label class="error">{{
                    errors.first(
                      "Short Description - " + langLabel(bannerItem.langCode)
                    )
                  }}</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.bannerImage") }}
                  <!-- <span style="color: red">*</span> -->
                </label>
                <div class="col-sm-10">
                  <div class="deleteImage" v-if="bannerItem.bannerImage" @click="bannerItem.bannerImage = ''">
                    <i class="fa fa-close"></i>
                  </div>
                  <file-upload
                    :fileUploadUrl="fileUploadUrl"
                    :filewidth="1320"
                    :fileheight="690"
                    :limit="5"
                    v-model="bannerItem.bannerImage"
                    :name="'Banner Image - ' + langLabel(bannerItem.langCode)"
                    @click="validateIt('Banner Image - ' + langLabel(bannerItem.langCode))"
                  >
                    <template v-slot:sizeError>
                      <div style="color: red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color: red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>1320 x 690, Max 5 MB.</template>
                  </file-upload>
                  <label class="error">{{ errors.first("Banner Image - " + langLabel(bannerItem.langCode)) }}</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.url") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="bannerItem.url"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Url - ' + langLabel(bannerItem.langCode)"
                      autocomplete="off"
                    />
                    <label class="error">{{
                      errors.first(
                        "Url - " + langLabel(bannerItem.langCode)
                      )
                    }}</label>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import fileupload from "../components/common/fileupload";
import config from "../config";

export default {
  name: "TopBannerDetail",
  mixins: [config.globalMixin],
  data() {
    return {
      // bannerImage: "",
      bannerDetail: {},
    };
  },
  created() {
    let langMap = [];
    this.langKey.forEach((element) => {
      langMap.push({ 
        langCode: element,
        bannerImage: "",
      });
    });
    this.$set(this.bannerDetail, "langMap", langMap);
    this.init();
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.id = id;
        let data = await this.$store.dispatch("getTopBannerDetail",this.setFormData(obj));
        let langMap = [];
        this.langKey.forEach((element) => {
          for (var i = 0; i < data.data.result.langMap.length; i++) {
            if (data.data.result.langMap[i].langCode == element) {
              langMap.push(data.data.result.langMap[i]);
            }
          }
        });
        data.data.result.langMap = langMap;
        // this.bannerImage = data.data.result.langMap[0].bannerImage
        this.$set(this, "bannerDetail", data.data.result);
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          // this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        // for(let i=0; i<this.bannerDetail.langMap.length; i++) {
        //   this.bannerDetail.langMap[i].bannerImage = this.bannerImage;
        // }
        obj.langData = JSON.stringify(this.bannerDetail.langMap);

        if (this.$route.query.id) {
          var data = await this.$store.dispatch("updateTopBanner", this.setFormData(obj));
        } else {
          var data = await this.$store.dispatch("createTopBanner", this.setFormData(obj));
        }

        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (error) {
        console.error(error);
      }
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
  },
  components: {
    "file-upload": fileupload,
  },
  computed: {},
};
</script>

<style scoped>
.bannerImage img {
  width: 300px;
}
</style>